import { AppFooter, GlobalAlerts } from '@core-systems/frontend-shared';
import { getEnvironment } from '@env';
import { Outlet } from '@tanstack/react-router';
import { useGlobalAlerts } from '../../hooks/useGlobalAlerts';
import { ZoneDataProvider } from '../../provider/ZoneDataProvider';
import AppHeader from '../AppHeader/AppHeader';

import './RootLayout.scss';

function RootLayoutContent() {
  const [alerts, dismissAlert] = useGlobalAlerts();

  return (
    <>
      <GlobalAlerts alerts={alerts} onDismiss={dismissAlert} baseUrl={getEnvironment().siteUrls.bom} />
      <AppHeader />
      <ZoneDataProvider>
        <Outlet />
      </ZoneDataProvider>
      <AppFooter baseUrl={getEnvironment().siteUrls.bom} />
    </>
  );
}

const RootLayout = () => <RootLayoutContent />;

export default RootLayout;
